import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import AppLayout from "../../components/layout/AppLayout";
import Sidebar from "../../components/layout/Sidebar/Sidebar";

import { procurementNavigation } from "./navigation";
import ProcurementRoutes from "./routes";

function getActiveItem(pathname) {
if (pathname.startsWith("/procurement/requests")) {
return "requests";
}

if (pathname.startsWith("/procurement/suppliers")) {
return "suppliers";
}

if (pathname.startsWith("/procurement/products")) {
return "products";
}

if (pathname.startsWith("/procurement/calendar")) {
return "calendar";
}

if (pathname.startsWith("/procurement/chat")) {
  return "chat";
}

return "dashboard";
}

export default function ProcurementApp({ user, role }) {
const navigate = useNavigate();
const location = useLocation();

const activeItem = getActiveItem(location.pathname);

return (
<AppLayout
user={user}
sidebar={ <Sidebar
       items={procurementNavigation}
       active={activeItem}
       onNavigate={navigate}
     />
}
> <div className="procurement-content"> <ProcurementRoutes /> </div> </AppLayout>
);
}
